import { defineStore } from "pinia";
import { ref } from "vue";

const SHOW_DELAY_MS = 150;
const MIN_DISPLAY_MS = 200;

export const useNavigationLoaderStore = defineStore("navigationLoader", () => {
  const loading = ref(false);
  // set while the app is still waiting on auth/config after a few seconds
  const slowConnection = ref(false);
  const showTimestamp = ref(0);
  const hideRequested = ref(false);
  let showTimeoutId: ReturnType<typeof setTimeout> | null = null;

  async function show() {
    hideRequested.value = false;
    showTimestamp.value = Date.now();

    if (showTimeoutId) {
      clearTimeout(showTimeoutId);
    }

    showTimeoutId = setTimeout(() => {
      if (!hideRequested.value) {
        loading.value = true;
      }
    }, SHOW_DELAY_MS);
  }

  async function hide() {
    hideRequested.value = true;

    if (showTimeoutId) {
      clearTimeout(showTimeoutId);
      showTimeoutId = null;
    }

    if (!loading.value) {
      return;
    }

    const elapsed = Date.now() - showTimestamp.value;
    if (elapsed < MIN_DISPLAY_MS) {
      await new Promise((resolve) => setTimeout(resolve, MIN_DISPLAY_MS - elapsed));
    }
    loading.value = false;
  }

  return { loading, slowConnection, show, hide };
});
